import { ApplicationState } from '@/redux/stores/types'

import { IAction } from '../actions/action-helpers'
import { CompanyTypeModal } from '../actions/actions.types'

type CompanyTypeModalState = ApplicationState['companyTypeModal']

function companyTypeModal(state: CompanyTypeModalState = { showModal: false }, action: IAction): CompanyTypeModalState {
	switch (action.type) {
		case CompanyTypeModal.ShowMyCompanyModal:
			return { ...action.payload }
		case CompanyTypeModal.HideMyCompanyModal:
			return { ...action.payload }
	}
	return state
}

export default companyTypeModal
